module.exports = __webpack_public_path__ + "static/media/plus.4e6b2e6a.png";